import {inject, Injectable} from "@angular/core";
import StackdriverErrorReporter from 'stackdriver-errors-js';
import {environment} from "../../environments/environment";
import {FIREBASE_AUTH} from '../../app/config/module.di.tokens';


@Injectable({
  providedIn: 'root'}
)
export class ErrorReportingApi {

  private errorHandler;

  auth = inject(FIREBASE_AUTH);

  private setUp() {
    this.errorHandler = new StackdriverErrorReporter();
    this.errorHandler.start({
      key: environment.errorReporting.apiKey,
      projectId: environment.firebase.projectId,
      reportUncaughtExceptions: true,
      disables: environment.errorReporting.disabled,
    });
  }

  public report(data: any) {
    try {
      if (!this.errorHandler) {
        this.setUp();
      }
      const user = this.auth.currentUser
      if (user) {
        this.errorHandler.setUser(user.uid);
      }
      this.errorHandler.report(new Error(JSON.stringify(data)));
    } catch (e) {
      console.warn(e)
    }
  }
}
